<template>
    <website-page>
        <wifi-navigation></wifi-navigation>
        <div class="main-section overlay">
            <b-container>
                <h1 class="blured" v-tr>Any hardware Unlimited Power|Technologie standard possibilités infinies</h1>
                <h2 class="subtitle blured" v-tr>Eye-In Media: designed for everyone, optimized for Cisco
                    Meraki|Eye-In Media: conçu pour tous, optimisé pour Cisco Meraki</h2>
                <p class="presentation" v-tr>
                    Our Cloud Managed Solution uses the standard RADIUS protocol, which allows it to work on any existing and future
                    hardware solutions.
                    Our solution is already integrated with all the existing manufacturer: Cisco Meraki, Fortigate, Nuclias by D-Link,
                    Mikrotik...|
                    Notre solution gérée dans le cloud utilise le protocole standard RADIUS, qui lui permet de fonctionner sur n'importe quelle
                    solutions matérielles, existante ou future.
                    Notre solution est déjà intégrée à tous les constructeurs existants: Cisco Meraki, Fortigate, Nuclias by D-Link, Mikrotik ...
                </p>
                <hr>
                <h3 class="mt-5" v-tr>Works with|Fonctionne avec</h3>
                <b-row class="mt-4">
                    <b-col cols="6" lg="4" xl="2" class="partner">
                        <b-img fluid :src="require('../../assets/img/partners/eyein-partner-cisco-meraki.png')"
                               alt="Eye-In Media Partner with Cisco Meraki"></b-img>
                    </b-col>
                    <b-col cols="6" lg="4" xl="2" class="partner">
                        <b-img fluid :src="require('../../assets/img/partners/eyein-partner-nuclias.png')"
                               alt="Eye-In Media Partner with Nuclias by D-Link"></b-img>
                    </b-col>
                    <b-col cols="6" lg="4" xl="2" class="partner">
                        <b-img fluid :src="require('../../assets/img/partners/eyein-partner-mikrotik.png')"
                               alt="Eye-In Media Partner with Mikrotik"></b-img>
                    </b-col>
                    <b-col cols="6" lg="4" xl="2" class="partner">
                        <b-img fluid :src="require('../../assets/img/partners/eyein-partner-aruba.png')"
                               alt="Eye-In Media Partner with Aruba"></b-img>
                    </b-col>
                    <b-col cols="6" lg="4" xl="2" class="partner">
                        <b-img fluid :src="require('../../assets/img/partners/eyein-partner-peplink.png')"
                               alt="Eye-In Media Partner with Pepwave by Peplink"></b-img>
                    </b-col>
                    <b-col cols="6" lg="4" xl="2" class="partner">
                        <b-img fluid :src="require('../../assets/img/partners/eyein-partner-fortinet.png')"
                               alt="Eye-In Media Partner with Fortigate / Fortinet"></b-img>
                    </b-col>
                </b-row>
                <div class="mt-4">
                    <b-btn v-scroll-to="'#contact-us'" class="mr-2" variant="primary"><span v-tr>Contact Us|Contactez-nous</span></b-btn>
                    <b-btn v-if="!isMobileLayout" v-scroll-to="'#customer-journey'" variant="outline-light"><span v-tr>Customer Journey|Parcours client</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
<!--                    <b-img width="128" height="40" fluid :src="require('../../assets/img/features/eye-in-wireless-compatible-wifi-6.png')"-->
<!--                           alt="Eye-In Media compatible WiFi 6"></b-img>-->
                </div>

            </b-container>
        </div>

        <div id="customer-journey" class="page inverted">
            <b-container class="text-center">
                <h3 class="mb-3" v-tr>Customer Journey with Meraki and Cisco CMX|Parcours Client avec Meraki et Cisco CMX</h3>

                <div class="text-center mx-auto mb-3" style="max-width: 720px;">
                    <youtube-player iframe-src="https://www.youtube.com/embed/naP_YMNwMzk" :poster="require('../../assets/img/video-splash/customer-journey.jpg')">
                    </youtube-player>
                </div>

                <p v-tr>
                    View your Shopping Mall like you have never seen it! Our beautiful map not only allows you to manage all your equipment visually, but to also view your customers, who and where they are, where they went.|
                    Visualisez votre centre commercial comme vous ne l'avez jamais vu! Notre belle carte vous permet non seulement de gérer visuellement tout votre équipement, mais également de visualiser vos clients, qui et où ils se trouvent, où ils sont allés.
                </p>
                <p v-tr>
                    Our platform provides not just analytics, but actionable data, allowing you to manage zones, position your ads at specific locations.|
                    Notre plateforme fournit non seulement des analyses, mais des données actionnables, vous permettant de gérer des zones, de positionner vos annonces à des endroits spécifiques.
                </p>
                <p v-tr>
                    Oh and did we mentioned our powerful Speed Insight report?|
                    Oh, et avons-nous mentionné notre puissant rapport Speed Insight?
                </p>

                <div class="text-center mt-4">
                    <b-btn v-if="!isMobileLayout" v-scroll-to="'#customer-journey-heatmap'" variant="outline-light"><span v-tr>Customer Journey and Heatmaps|Parcours client et heatmaps</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="customer-journey-heatmap" class="page">
            <b-container>
                <h2 class="text-center mb-4" v-tr>Heatmap & Customer Journey|Heatmap & Parcours client</h2>
                <b-row>
                    <b-col md="6" lg="7">
                        <b-carousel controls indicators :interval="4000">
                            <b-carousel-slide :img-src="require('../../assets/img/screenshots/cmx-journey.jpg')"
                                              alt="Cisco CMX and Meraki geolocation map and analytics">
                            </b-carousel-slide>
                            <b-carousel-slide :img-src="require('../../assets/img/screenshots/cmx-stats.jpg')"
                                              alt="Cisco CMX and Meraki geolocation heatmap">
                            </b-carousel-slide>
                            <b-carousel-slide :img-src="require('../../assets/img/screenshots/cmx-annonces.jpg')"
                                              alt="Cisco CMX and Meraki customer journey">
                            </b-carousel-slide>
                        </b-carousel>
                    </b-col>
                    <b-col>
                        <h3 class="small" v-tr>Combine powerful data with geolocation technology|Combinez les profils de vos clients avec des données de géolocalisation</h3>
                        <p class="text-justify" v-tr>
                            Have more visibility on the habits and behaviors of your physical traffic: the number of visits, the time spent in your establishment, etc ...|
                            Ayez plus de visibilité sur les habitudes et comportements de votre trafic physique: le nombre de visites, le temps passé dans votre établissement, etc...
                        </p>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="feature" lg="4">
                        <b-card>
                            <b-img :src="require('../../assets/img/icons/report.png')"
                                   alt="Powerful WiFi Analytics and Reports"></b-img>
                            <h4 v-tr>Analytics and Report|Rapports et analytique</h4>
                            <p v-tr>
                                Discover what your customers are doing on site.|
                                Découvrez ce que vos clients font quand ils sont sur place.
                            </p>
                        </b-card>
                    </b-col>
                    <b-col class="feature" lg="4">
                        <b-card>
                            <b-img :src="require('../../assets/img/icons/money.png')"
                                   alt="WiFi Budget Management Tool"></b-img>
                            <h4 v-tr>Budget management|Gestion de budget</h4>
                            <p v-tr>
                                Which areas have the most trafic? Optimize your store layout.|
                                Quels sont les endroits les plus achalandés? Optimisez la disposition de vos établissements.
                            </p>
                        </b-card>
                    </b-col>
                    <b-col class="feature" lg="4">
                        <b-card>
                            <b-img :src="require('../../assets/img/icons/idea.png')"
                                   alt="Geocalised Advertising System"></b-img>
                            <h4 v-tr>Geolocalised ads|Annonces géolocalisés</h4>
                            <p v-tr>
                                Increase the effectiveness of your content, rent virtual advertising space to generate a direct ROI.|
                                Augmentez l'efficacité de vos contenus, louez des espaces de publicité virtuels pour générer un ROI direct.
                            </p>
                        </b-card>
                    </b-col>
                </b-row>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" v-scroll-to="'#integration'" variant="light"><span v-tr>Integration with Meraki|Intégration avec Meraki</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="integration" class="page inverted">
            <b-container class="text-center">
                <h3 class="mb-3" v-tr>Tightly Integrated with Meraki Cloud - Setup in 5 Minutes|Notre plateforme est déjà intégré avec Meraki Cloud - Configuration en 5 minutes</h3>

                <div class="text-center mx-auto mb-3" style="max-width: 720px;">
                    <b-embed type="iframe" aspect="16by9" allowfullscreen src="https://www.youtube.com/embed/1KsBcafPt70"></b-embed>
                </div>

                <p v-tr>
                    Eye-In WiFi Solution has complete integration with Meraki and CMX by Cisco, from WiFi login to detailed Customer Journey.|
                    Eye-In WiFi Solution a une intégration complète avec Meraki et CMX by Cisco, de la connexion WiFi au parcours client détaillé.
                </p>
                <p v-tr>
                    Enter a new era of WiFi Management brought by new Cloud Solutions that makes installation, configuration much easier and provide much more intelligence!|
                    Entrez dans une nouvelle ère de gestion WiFi apportée par de nouvelles solutions cloud qui facilitent l'installation, la configuration et fournissent beaucoup plus d'intelligence!
                </p>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-4" v-scroll-to="'#blog'" variant="outline-light"><span v-tr>To go further|Pour aller plus loin</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="blog" class="page">
            <b-container class="text-center">
                <h3 class="mb-4" v-tr>To go further|Pour aller plus loin</h3>

                <b-row>
                    <b-col cols="12" md="6">
                        <b-img fluid-grow rounded center :src="require('../../assets/img/news/news_hyperlocation_map.png')"></b-img>
                        <h4 class="mt-3" v-tr>Eye-In integration with Cisco CMX and Meraki|Intégration d'Eye-In avec Cisco CMX et Meraki</h4>
                        <p v-tr>
                            In February 2017, Eye-In Media in partnership with Bell and Cisco demonstrated our Universal Marketing Experience (UMX) platform on Cisco’s WiFi infrastructure installed at Bell’s Montreal based Solution Centre. UMX is a unified platform that includes the integration of Eye-Intelligence omnichannel CRM solution with Cisco’s Connected Mobile Experiences (CMX), platform leveraging its location-based services.|
                            En février 2017, Eye-In Media, en partenariat avec Bell et Cisco, a présenté sa plateforme d'expérience marketing universelle (UMX) sur l'infrastructure Wi-Fi de Cisco installée au Centre de solutions de Bell à Montréal. UMX est une plate-forme unifiée qui inclut l’intégration de la solution CRM omnicanal Eye-Intelligence avec les expériences mobiles connectées (CMX) de Cisco, la plate-forme tirant parti de ses services basés sur la localisation.
                        </p>
                        <router-link to="/blog/post/88DCF51C-AA57-43AD-A433-B0192B307468"><span v-tr>Read entire article|Lire l'article complet</span> <i class="fal fa-chevron-right ml-1"></i></router-link>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-img fluid-grow rounded center :src="require('../../assets/img/news/smart-city.jpg')"></b-img>
                        <h4 class="mt-3" v-tr>There’s a magical new “push” button at Eye-In Media|Il y a un bouton "magique" chez Eye-In Media</h4>
                        <p v-tr>
                            Thanks to our flawless integration with Meraki, a cloud-managed IT company that was acquired by Cisco in 2012, we can now deliver a new way for your Wi-Fi infrastructure to communicate with all of your departments more precisely, rapidly, and smoothly than ever before.|
                            Grâce à notre intégration sans faille avec Meraki, une société informatique gérée dans le cloud qui a été acquise par Cisco en 2012, nous pouvons désormais proposer un nouveau moyen pour votre infrastructure Wi-Fi de communiquer avec tous vos services de manière plus précise, rapide et fluide que jamais auparavant.
                        </p>
                        <router-link to="/blog/post/7F09201D-E770-41CB-A9D9-0BA8949A74B5"><span v-tr>Read entire article|Lire l'article complet</span> <i class="fal fa-chevron-right ml-1"></i></router-link>
                    </b-col>
                </b-row>

                <div class="text-center">
                    <b-btn v-if="!isMobileLayout" class="mt-4" v-scroll-to="'#contact-us'" variant="light"><span v-tr>Contact Us|Nous contacter</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>
    </website-page>
</template>

<script>

    import WifiNavigation from "@/navigation/wifi-navigation.vue";
    import {translate} from "../../../vue-components/helpers/i18n.js";
    export default {
        name: `wifi-technology`,
        components: {WifiNavigation},
        metaInfo: {
            title: translate(`Guest WiFi optimized for Cisco Meraki and CMX|WiFi invité optimisé pour Cisco Meraki et CMX`),
            meta: [
                { name: `keywords`, content: `cloud managed, solution, radius, protocol, Cisco, Meraki, Fortinet, Nuclias, D-Link, Mikrotik, Aruba, Pepwave, customer journey, cmx` },
                { name: `description`, content: translate(`Discover the Power of Customer Journey powered by Cisco Meraki and CMX|Découvrez la puissance du parcours client optimisé par Cisco Meraki et CMX`) }
            ]
        },
        activated() {
            if (this.$route.params.section) {
                this.$scrollTo(`#${this.$route.params.section}`);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main-section {
        background-color: #151e28;
        background-image: url('../../assets/img/backgrounds/technology.jpg');
        background-image: url('../../assets/img/backgrounds/technology.webp');
        background-size: cover;
    }

    .icon-list {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .fal,
        .fas {
            opacity: 0.8;
            font-size: 36px;
            padding: 15px;
            display: inline-flex;
            margin: 0 auto;
        }
    }
</style>
